export default "__VITE_ASSET__OrHaIYqQ__"